/* SA · Día de entrega — guarda el día elegido en el atributo «delivery» de la cesta (lo lee Boxmi)
   Las fechas vienen calculadas en Liquid (snippets/sa-dia-entrega.liquid). Aquí:
   1. Se descartan las que ya han pasado la hora de corte (por si la página estaba en caché).
   2. Se guarda la fecha marcada nada más cargar la cesta (aunque el cliente aún no vea el selector)
      y cada vez que elige otra.
   3. Pasos: en la cesta el botón dice «Continuar» y lleva a la pantalla de entrega; allí dice
      «Ir a pagar», que abre la ventana de sugerencias (assets/sa-empuje.js) y luego el pago.
   4. El botón de pagar no continúa hasta que el atributo está guardado. */
(function () {
  'use strict';

  var ATRIBUTO = 'delivery';
  var VISIBLES = 3;
  var PASO_CAJON = 'sa-paso-entrega';          /* en <cart-drawer> */
  var PASO_PAGINA = 'sa-paso-entrega-pagina';  /* en <body>, página /cart */
  var RAIZ = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/').replace(/\/?$/, '/');

  var guardada = null;  /* último valor que sabemos que tiene la cesta en Shopify */
  var enCurso = null;   /* { valor, promesa } del guardado en marcha */

  function bloques() { return document.querySelectorAll('[data-sa-dia="cajon"], [data-sa-dia="cesta"]'); }

  /* Fecha y hora de pared en Madrid, sin depender de la zona horaria del ordenador del cliente */
  function ahoraMadrid() {
    var p = {};
    new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
    return { fecha: p.year + '-' + p.month + '-' + p.day, hora: +p.hour % 24 };
  }

  /* Oculta las fechas cuyo día de envío ya no vale y deja visibles las 4 primeras válidas.
     Devuelve el valor (DD-MM-AAAA) que queda marcado, o null si no queda ninguna. */
  function validar(bloque) {
    var corte = parseInt(bloque.getAttribute('data-corte'), 10);
    var ahora = ahoraMadrid();
    var visibles = 0;
    var marcada = null;
    var primera = null;
    bloque.querySelectorAll('input[data-fecha]').forEach(function (input) {
      var envio = input.getAttribute('data-envio');
      var vale = envio > ahora.fecha || (envio === ahora.fecha && ahora.hora < corte);
      var mostrar = vale && visibles < VISIBLES;
      if (mostrar) visibles++;
      input.closest('.sa-dia__opcion').hidden = !mostrar;
      input.disabled = !mostrar;
      if (mostrar && !primera) primera = input;
      if (mostrar && input.checked) marcada = input;
      if (!mostrar) input.checked = false;
    });
    if (!marcada && primera) { primera.checked = true; marcada = primera; }
    bloque.hidden = !marcada;
    var valor = marcada ? marcada.getAttribute('data-fecha') : null;
    var campo = bloque.querySelector('[data-sa-dia-campo]');
    if (campo) campo.value = valor || '';
    return valor;
  }

  /* Marca el mismo día en todos los selectores de la página (cesta lateral y /cart) */
  function marcarEnTodos(valor) {
    bloques().forEach(function (b) {
      var input = b.querySelector('input[data-fecha="' + valor + '"]:not([disabled])');
      if (input) input.checked = true;
      validar(b);
    });
  }

  function guardar(valor) {
    if (!valor) return Promise.reject(new Error('sin fecha'));
    if (valor === guardada && !enCurso) return Promise.resolve(valor);
    if (enCurso && enCurso.valor === valor) return enCurso.promesa;
    var datos = { attributes: {} };
    datos.attributes[ATRIBUTO] = valor;
    var promesa = window.fetch(RAIZ + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(datos)
    })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (cart) {
        var enCesta = cart && cart.attributes ? cart.attributes[ATRIBUTO] : null;
        if (enCesta !== valor) throw new Error('la cesta no ha guardado el día');
        guardada = valor;
        return valor;
      });
    enCurso = { valor: valor, promesa: promesa };
    var limpiar = function () { if (enCurso && enCurso.promesa === promesa) enCurso = null; };
    promesa.then(limpiar, limpiar);
    return promesa;
  }

  /* Revisa todos los selectores y guarda si lo marcado no coincide con lo que tiene la cesta */
  function revisar() {
    var lista = bloques();
    if (!lista.length) return;
    var valor = null;
    lista.forEach(function (b) {
      var g = b.getAttribute('data-guardada');
      if (guardada === null && g !== null) guardada = g;
      var v = validar(b);
      if (!valor) valor = v;
    });
    if (valor && valor !== guardada) guardar(valor).catch(function () {});
  }

  function mostrarError(boton) {
    var ctas = boton.closest('.cart__ctas') || boton.parentNode;
    var aviso = ctas.querySelector('.sa-dia__error');
    if (!aviso) {
      aviso = document.createElement('p');
      aviso.className = 'sa-dia__error';
      aviso.setAttribute('role', 'alert');
      ctas.insertBefore(aviso, ctas.firstChild);
    }
    aviso.textContent = 'No hemos podido guardar tu día de entrega. Inténtalo de nuevo, por favor.';
  }

  /* El cliente elige otro día */
  document.addEventListener('change', function (ev) {
    var input = ev.target;
    if (!input.matches || !input.matches('[data-sa-dia="cajon"] input[data-fecha], [data-sa-dia="cesta"] input[data-fecha]')) return;
    var valor = input.getAttribute('data-fecha');
    marcarEnTodos(valor);
    guardar(valor).catch(function () {});
  });

  /* ---------- Pasos: Cesta › Entrega › Pagar ---------- */
  function contenedorDe(bloque) {
    var cajon = bloque.closest('cart-drawer');
    return cajon ? { nodo: cajon, clase: PASO_CAJON } : { nodo: document.body, clase: PASO_PAGINA };
  }
  function enPaso(bloque) { var c = contenedorDe(bloque); return c.nodo.classList.contains(c.clase); }

  function entrarPaso(bloque) {
    validar(bloque);
    var c = contenedorDe(bloque);
    c.nodo.classList.add(c.clase);
    var pie = bloque.closest('.drawer__footer');
    if (pie) pie.scrollTop = 0;
    else window.scrollTo({ top: 0, behavior: 'smooth' }); /* sin la lista de productos, el paso queda arriba */
    var marcada = bloque.querySelector('input[data-fecha]:checked');
    if (marcada) marcada.focus({ preventScroll: true });
  }

  function salirPaso(bloque) {
    var c = contenedorDe(bloque);
    c.nodo.classList.remove(c.clase);
    var boton = c.nodo.querySelector('button[name="checkout"]');
    if (boton) boton.focus({ preventScroll: true });
    if (c.clase === PASO_PAGINA) window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  document.addEventListener('click', function (ev) {
    var volver = ev.target.closest && ev.target.closest('[data-sa-dia-volver]');
    if (!volver) return;
    var bloque = volver.closest('[data-sa-dia]');
    if (bloque) salirPaso(bloque);
  });

  /* Al cerrar la cesta lateral, la próxima vez se abre otra vez en el resumen */
  function vigilarCierreCajon() {
    var cajon = document.querySelector('cart-drawer');
    if (!cajon) return;
    new MutationObserver(function () {
      if (!cajon.classList.contains('active') && cajon.classList.contains(PASO_CAJON)) cajon.classList.remove(PASO_CAJON);
    }).observe(cajon, { attributes: true, attributeFilter: ['class'] });
  }

  /* Botón de la cesta: «Continuar» lleva al paso de entrega; «Ir a pagar» exige el día guardado.
     Escucha en window (fase de captura) para adelantarse a la ventana de sugerencias de
     assets/sa-empuje.js, que también captura el clic en document y lo corta. */
  window.addEventListener('click', function (ev) {
    var boton = ev.target.closest && ev.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"]');
    if (!boton || boton.disabled || boton.hasAttribute('data-sa-dia-ok')) return;
    var lista = bloques();
    if (!lista.length) return;
    var bloque = document.querySelector(boton.closest('cart-drawer') ? '[data-sa-dia="cajon"]' : '[data-sa-dia="cesta"]') || lista[0];

    /* Paso 1 → 2: aún está viendo el resumen de la cesta */
    if (boton.matches('button[name="checkout"]') && !enPaso(bloque)) {
      ev.preventDefault();
      ev.stopImmediatePropagation();
      entrarPaso(bloque);
      return;
    }

    var valor = validar(bloque);
    marcarEnTodos(valor);
    if (valor && valor === guardada && !enCurso) return;

    ev.preventDefault();
    ev.stopImmediatePropagation();
    boton.classList.add('sa-cargando');
    boton.setAttribute('aria-busy', 'true');
    guardar(valor)
      .then(function () {
        boton.classList.remove('sa-cargando');
        boton.removeAttribute('aria-busy');
        var error = document.querySelector('.sa-dia__error');
        if (error) error.remove();
        boton.setAttribute('data-sa-dia-ok', '1');
        boton.click();
        setTimeout(function () { boton.removeAttribute('data-sa-dia-ok'); }, 1500);
      })
      .catch(function () {
        boton.classList.remove('sa-cargando');
        boton.removeAttribute('aria-busy');
        mostrarError(boton);
      });
  }, true);

  /* La cesta lateral se vuelve a pintar entera cada vez que cambia: revisamos el selector nuevo */
  function vigilar() {
    var pendiente = false;
    new MutationObserver(function (cambios) {
      if (pendiente) return;
      var hay = cambios.some(function (c) {
        return Array.prototype.some.call(c.addedNodes, function (n) {
          return n.nodeType === 1 && (n.matches('[data-sa-dia]') || n.querySelector('[data-sa-dia]'));
        });
      });
      if (!hay) return;
      pendiente = true;
      requestAnimationFrame(function () {
        pendiente = false;
        /* El selector recién pintado trae lo que había guardado en Shopify en ese momento */
        guardada = null;
        revisar();
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  function iniciar() {
    revisar();
    vigilar();
    vigilarCierreCajon();
    /* Si la página se queda abierta y pasa la hora de corte, que se mueva sola */
    setInterval(revisar, 30000);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) revisar(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) revisar(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar); else iniciar();
})();
